module.exports = __webpack_public_path__ + "img/account-settings-header.1c7ed4ea.svg";